import styles from './TrackThumbnail.module.scss';

const TrackThumbnail = ({ isPlaying, isSelected, url }) => {
  const className = `${styles.playlistTrackThumbnail} ${isSelected ? styles.selected : ''} ${
    isPlaying ? styles.playing : ''
  }`;

  return (
    <div className={className}>
      <div className={styles.buttonContainer}></div>
      <img src={url} alt="" />
    </div>
  );
};

export default TrackThumbnail;
